import type { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import { useBreakpoints } from '@/core/tamagoshi/MediaQuery/MediaQuery';
import { isB2B, isB2C } from '@/domains/core/settings/utils';
import { RecommendationPlaylistSkeleton } from '@/domains/productDiscovery/Recommendation/components/Playlists/components/RecommendationPlaylistSkeleton/RecommendationPlaylistSkeleton';
import { useSelectA2cFBTEngine } from '@/domains/productDiscovery/Recommendation/hooks/useSelectA2cFBTEngine/useSelectA2cFBTEngine';
import { ProductRecommendation } from '@/domains/productDiscovery/Recommendation/modules/ProductRecommendation/ProductRecommendation';
import { selectAddToCartModalIsFetching } from '@/domains/shoppingCart/selectors/selectAddToCartModalIsFetching';

import styles from '../CommonStyles.module.scss';

export const FBTContainerA2C: FunctionComponent = () => {
  const { recoEngineConfig, recoEngineSelector, recoEngineConfigSelector } =
    useSelectA2cFBTEngine();

  const isFetching = useSelector(selectAddToCartModalIsFetching);

  const { isSizeBelow } = useBreakpoints();
  const isMobile = isSizeBelow('md');

  if (isFetching)
    return (
      <div className={styles.playlistsWrapper}>
        <RecommendationPlaylistSkeleton />;
      </div>
    );

  if (!recoEngineConfig) {
    return null;
  }

  return (
    <ProductRecommendation
      className={styles.recommendation}
      sliderClassName={styles.slider}
      withProductCardsLight={isB2C() || isMobile}
      playlistLocation="A2C_Popin"
      placeHolderSelector={recoEngineConfigSelector}
      recommendationSelector={recoEngineSelector}
      addToCart
      isBrandsFilterEnabled={isB2B()}
      hasPlaceholder={false}
    />
  );
};
